import styled from 'styled-components';
import { ITypography, typographyProps } from './types';

export const Span = styled.span<ITypography>`
  ${typographyProps};
`;

export const MediumInfo = styled(Span)`
  font-size: 13px;
`;

export const SmallInfo = styled(Span)`
  font-size: 12px;
  line-height: 16px;
`;

SmallInfo.defaultProps = {
  color: 'grayBlue',
};
